<template>
  <div class="table-data-members">
    <Avatar :value="items" />
  </div>
</template>

<script>
import Avatar from '@/components/Avatar'

export default {
  props: {
    value: {
      type: [Array, Object],
      default: () => [],
    },
  },
  computed: {
    items() {
      if (!this.value) return []
      const value = this.value instanceof Array ? this.value : [this.value]
      return value.map(item => ({ name: item.name, src: item.avatar }))
    },
  },
  components: {
    Avatar,
  },
}
</script>
